import { useLayoutEffect, useState } from "react";

export function useTextOverflowConditionalTooltip(
  textRef: React.RefObject<HTMLDivElement>
) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipOpen, tooltipSetOpen] = useState(false);

  // Validate if the textis overflowing, if so, allow the tooltip to be toggled
  useLayoutEffect(() => {
    if (textRef.current) {
      const isOverflowing =
        textRef.current.scrollWidth > textRef.current.clientWidth;
      setShowTooltip(isOverflowing);
    }
  }, [textRef]);

  const handleTooltipClose = () => {
    if (!showTooltip) return;
    tooltipSetOpen(false);
  };

  const handleTooltipOpen = () => {
    if (!showTooltip) return;
    tooltipSetOpen(true);
  };

  return {
    open: tooltipOpen,
    onClose: handleTooltipClose,
    onOpen: handleTooltipOpen,
  };
}
